"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var conversation_id_serialiser_1 = require("./../../conversation/conversation-id-serialiser");
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var session_properties_event_serialiser_1 = require("./../../services/control/session-properties-event-serialiser");
var session_properties_event_batch_1 = require("./session-properties-event-batch");
/**
 * Serialiser for {@link SessionPropertiesEventBatch}
 */
var SessionPropertiesEventBatchSerialiserClass = /** @class */ (function (_super) {
    __extends(SessionPropertiesEventBatchSerialiserClass, _super);
    function SessionPropertiesEventBatchSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link SessionPropertiesEventBatch} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link SessionPropertiesEventBatch} that was read
     */
    SessionPropertiesEventBatchSerialiserClass.prototype.read = function (bis) {
        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
        var events = Codec.readCollection(bis, session_properties_event_serialiser_1.SessionPropertiesEventSerialiser.read);
        return new session_properties_event_batch_1.SessionPropertiesEventBatch(cid, events);
    };
    return SessionPropertiesEventBatchSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.SessionPropertiesEventBatchSerialiserClass = SessionPropertiesEventBatchSerialiserClass;
/**
 * The {@link SessionPropertiesEventBatchSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.SessionPropertiesEventBatchSerialiser = new SessionPropertiesEventBatchSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/session-properties-event-batch-serialiser.js
// module id = 1293
// module chunks = 1